import './styles.css';
import './assets/styles/transitions.css';
import '@vuepic/vue-datepicker/dist/main.css';

// import Datepicker from '@vuepic/vue-datepicker';
import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import mitt from 'mitt';
import FormButton from './components/elements/FormButton.vue';
import FormCheckbox from './components/elements/FormCheckbox.vue';
import FormInput from './components/elements/FormInput.vue';
import FormSelect from './components/elements/FormSelect.vue';
// import FormDateSelect from '@/components/elements/FormDateSelect.vue';

import SlotPageTitle from './components/slots/SlotPageTitle.vue';
import SlotPageWrapper from './components/slots/SlotPageWrapper.vue';

import App from './App.vue';
import router from './router/index.ts';

import networkController from './js/networkController.js';

const app = createApp(App);
const emitter = mitt();

app.component('FormButton', FormButton);
app.component('FormCheckbox', FormCheckbox);
app.component('FormInput', FormInput);
app.component('FormSelect', FormSelect);


//Асинхронная загрузка компоненты глобально
const FormDateSelect = defineAsyncComponent({
  loader: () => import('@/components/elements/FormDateSelect.vue'),
})

app.component('FormDateSelect', FormDateSelect);

app.component('SlotPageTitle', SlotPageTitle);
app.component('SlotPageWrapper', SlotPageWrapper);


const Datepicker = defineAsyncComponent({
  loader: () => import('@vuepic/vue-datepicker'),
})

app.component('Datepicker', Datepicker);

app.use(createPinia()).use(router);

app.provide('emitter', emitter);
// Inject Yandex.Metrika only for production builds
if (import.meta.env.MODE === 'production') {
  (function(m,i){ m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date(); })(window,'ym');
  const _ymSrc = 'https://mc.yandex.ru/metrika/tag.js?id=105889144';
  let already = false;
  for (let s of document.scripts) { if (s.src === _ymSrc) { already = true; break; } }
  if (!already) {
    const k = document.createElement('script');
    k.async = true;
    k.src = _ymSrc;
    document.getElementsByTagName('head')[0].appendChild(k);
  }
  ym(105889144, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:'dataLayer', accurateTrackBounce:true, trackLinks:true});
}

app.mount('#app');

networkController.interceptors.response.use(response => response, error => {
  console.log(error);

  if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
    console.log('Request timed out');
    emitter.emit('addEvent', {
      label: 'Ошибка',
      message: 'Превышено время ожидания ответа от сервера.',
      status: 'error'
    });
    return Promise.reject(error);
  }

  if (error.code === 'ERR_NETWORK' || error.code === 'ERR_BAD_RESPONSE') {
    emitter.emit('addEvent', {
      label: 'Ошибка сервера',
      message: `Что-то сломалось. Приносим извинения за неудобства.
       Мы работаем над исправлением ситуации. Пожалуйста, повторите попытку позже.`,
      status: 'error'
    });
    return Promise.reject(error);
  }
  Promise.reject(error);
});
